import { Card } from "@/skyjo/game";


interface CardMouvement {
    card: Card,
    swap: boolean,
    steps: string[],
    timer: number
}

interface CardProperties {
    width: number,
    height: number,
    x: number,
    y: number
    fontSize: string
}

export class Animate {

    animationOffsetDuration: number = 2000
    animation: Array<CardMouvement> = []

    start() {
        requestAnimationFrame(() => {
            const animations: (Animation | undefined)[] = []
            this.animation.forEach(cardMouvement => {
                animations.push(this.returnCard(cardMouvement))
                animations.push(this.translateCard(cardMouvement))
                animations.push(this.zIndexCard(cardMouvement))
            })
            animations.forEach((animation: Animation | undefined) => {
                if (animation)
                    animation.play();
            });
        });
    }

    reset() {
        this.animation = []
        return this
    }

    add(card: Card, swap: boolean = false, steps: string | undefined = undefined, timer: number = 0): this {

        const cardFind = this.animation.find((cardMov) => {
            return card === cardMov.card
        })
        if (cardFind && steps) {
            cardFind.steps.push(steps)
            cardFind.timer = 2 - cardFind.steps.length
        } else {
            const cardMouvement: CardMouvement = { card, swap, steps: (steps ? [steps] : []), timer };
            this.animation.push(cardMouvement)
        }
        return this
    }

    getKeyFrames(cardMouvement: CardMouvement): Keyframe[] | undefined {

        let offset = cardMouvement.timer / 2
        const easing = "cubic-bezier(0.4, 0, 0.2, 1)"
        const coords: CardProperties[] = []
        const keyFrames: Keyframe[] = []

        cardMouvement.steps.forEach((elementId) => {
            const element = document.getElementById(`${elementId}`)
            const cardCoord: CardProperties | undefined = this.getCardProperties(element)
            if (cardCoord)
                coords.push(cardCoord)
        })
        if (coords[0])
            coords.unshift(coords[0])

        const lastElement = document.getElementById(`card${cardMouvement.card.id}`)
        const lastCoord: CardProperties | undefined = this.getCardProperties(lastElement)
        if (!lastCoord)
            return
        coords.push(lastCoord)


        coords.forEach((coord, index) => {
            if (!lastCoord)
                return

            const transform = `translate(${coord.x - lastCoord.x}px,${coord.y - lastCoord.y}px)`
            const height = coord.height + "px"
            const width = coord.width + "px"
            const fontSize = coord.fontSize


            keyFrames.push({ transform, height, width, fontSize, easing, offset: (index === 0) ? 0 : offset })
            offset += (index === 0) ? 0 : 0.5
        });

        return keyFrames
    }

    getCardProperties(element: Element | null) {
        if (!element)
            return
        const fontSize = getComputedStyle(element).fontSize
        const { width, height, x, y } = element.getBoundingClientRect()
        return { width, height, x, y, fontSize }
    }

    translateCard(cardMouvement: CardMouvement) {
        const card = document.querySelector(`#card${cardMouvement.card?.id}`)

        if (!card || !cardMouvement.steps)
            return

        const keyFrames: Keyframe[] | undefined = this.getKeyFrames(cardMouvement)
        if (!keyFrames)
            return
        return new Animation(new KeyframeEffect(card, keyFrames,
            { duration: this.animationOffsetDuration }))
    }

    returnCard(cardMouvement: CardMouvement) {
        const card = document.querySelector(`#card${cardMouvement.card?.id} > div`)
        if (!card || !cardMouvement.swap)
            return

        const keyFrames: Keyframe[] = [
            { transform: "rotate3d(0,1,0,180deg)", offset: 0 },
            { transform: "rotate3d(0.2,1,0,90deg) translateZ(50px)", offset: 0.5 },
            { transform: "rotate3d(0,1,0,0deg)", offset: 1 }]
        return new Animation(new KeyframeEffect(card, keyFrames,
            { duration: this.animationOffsetDuration / 2, easing: "cubic-bezier(0.4, 0, 0.2, 1)" }))
    }

    zIndexCard(cardMouvement: CardMouvement) {
        const card = document.querySelector(`#card${cardMouvement.card?.id}`)

        if (!card)
            return
        const zIndex = cardMouvement.timer === 0 ? 3 : 2
        const keyFrames: Keyframe[] = [
            { zIndex, offset: 0 }, { zIndex: 2, offset: 0.5 }, { zIndex: 2, offset: 1 }, { offset: 1 },]
        return new Animation(new KeyframeEffect(card, keyFrames,
            { duration: this.animationOffsetDuration }))
    }
}

